const article = {
	slug: "three-questions-before-you-deploy-ai",
	title: "Three Questions Banks Ask Before Deploying AI",
	date: "18 April 2026",
	updated: null,
	description:
		"Financial services forces three questions before any AI system ships. They come from banking regulation, but they apply to any software making decisions on someone's behalf.",
	keywords: [
		"AI governance",
		"AI deployment",
		"model risk",
		"SR 11-7",
		"financial services AI",
		"AI accountability",
	],
	tldr: "Before you deploy AI, answer three questions: who owns it, what does failure look like, and who is checking next month. FinServ got forced into this by regulators. Everyone else can choose it as an advantage.",
	readingTime: null,
	provenance: "Adapted from my LinkedIn post, April 2026.",
	provenanceUrl: null,
	series: "ai-governance-for-finserv-leaders",
	artifact: "deploy-risk-assessment",
	markdown: `Getting an AI system approved in financial services feels like explaining your career choices to a desi parent.

Three questions. Every time. Non-negotiable.

I spent 15 years building systems that had to pass these reviews. I was the engineer on the other side of the table, defending my work line by line. I failed a few reviews. I learned more from those than from the approvals.

These three questions sit underneath the SR 11-7 framework that governs model risk in banking. They are the same questions every business owner should ask before deploying AI.

## Who owns this?

One person. Named. Reachable at 2am when the output is wrong and someone important is noticing.

"The whole team is responsible" means nobody is responsible.

## What does failure actually look like?

Not "it might give wrong answers." Specifically. What breaks? Who gets hurt?

I watched a review stop cold because the answer was "we haven't really thought about that." The model did not ship that sprint.

## Who is checking next month?

AI systems drift. The model that worked in January may quietly go sideways by March because your data changed, the base model updated, or the world shifted.

Set it and forget it is fine for a slow cooker. Not for software making decisions on your behalf.

## Regulation forced the question. You can choose it.

These questions come from banking regulation. But they apply to any software making decisions on someone's behalf. Mission-critical teams figured this out because the cost of skipping them shows up immediately.

FinServ just got forced to answer them first by regulators. The rest get to choose it as a competitive advantage to increase the bottom line.

Turns out asking hard questions before someone makes a big decision is just good parenting.`,
};

export default article;
